import React, { Component } from 'react'
import styled from 'styled-components'
import Row from '../components/Row'
import Text from '../components/Text'

const Button = styled.button`
  padding: 0.75rem;
  cursor: pointer;
  width: 100%;
  background: ${props => props.checked ? `var(--${props.color})` : 'var(--light-gray)'};
  color: ${props => props.checked ? '#fff' : '#000'};
  transition: all 0.2s;
  display: flex;
  align-items: center;
  color: ${props => props.checked ? '#fff' : '#000'};
  flex: 1;
  text-align: left;
  margin-bottom: 1em;
  &:last-child {
    margin-bottom: 0;
  }
`

const Check = styled.div`
  font-size: 1.2rem;
  margin-right: 0.5rem;
`

export default class Toggle extends Component {
  render() {
    const { checked, color, value, str, onToggle, radio, disabled, style } = this.props

    return (
      <Button
        color={color}
        checked={checked}
        type="button"
        disabled={disabled}
        onClick={() => onToggle(value)}
        style={style}
      >
        <Row>
          <Check
            checked={checked}
            className={(
              (radio && `far ${checked ? 'fa-dot-circle' : 'fa-circle'}`) ||
              `far ${checked ? 'fa-check-square' : 'fa-square'}`
            )}
          />
          <Row.Cell>
            <Text str={str} />
          </Row.Cell>
        </Row>
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Toggle.js